import React, { FC, useEffect, useState } from 'react';

import { calculateScore } from '../../../utils/score-calculator';
import * as CSS from '../match-entry-styles';
import { Player } from '../../../../database.schema';
import { useFetchPlayers } from '../../../api/hooks/use-fetch-players';

type ScoreEntryProps = {
  playerId: number;
  handicap: number;
  strokeIndex: number;
  par: number;
  score: number;
  team: string;
  setPlayerData: (playerId: number, recordedScore: number, team: string) => void;
  matchShots: number;
};

export const HoleScore: FC<ScoreEntryProps> = ({ score, par, strokeIndex, handicap, setPlayerData, playerId, team, matchShots }): JSX.Element => {
  const { data } = useFetchPlayers();
  const players = data as Array<Player>;
  const [playerScore, setPlayerScore] = useState(score);
  const [playerPoints, setPlayerPoints] = useState(calculateScore({ handicap, par, score, strokeIndex }));

  const calculatePointsAndScore = (handicap: number, recordedScore: number, strokeIndex: number, par: number) => {
    const calculatedPoints = calculateScore({ handicap, par, score: recordedScore, strokeIndex });
    setPlayerPoints(calculatedPoints);
    setPlayerScore(recordedScore);

    setPlayerData(playerId, recordedScore, team);
  };

  useEffect(() => {
    calculatePointsAndScore(handicap, score, strokeIndex, par);
  }, [par, strokeIndex, handicap, score]);

  const decrementScore = () => {
    const decrementedScore = playerScore - 1;
    calculatePointsAndScore(handicap, decrementedScore, strokeIndex, par);
  };
  const incrementScore = () => {
    const incrementedScore = playerScore + 1;
    calculatePointsAndScore(handicap, incrementedScore, strokeIndex, par);
  };

  return (
    <CSS.ScoreEntryWrapper data-testid="hole-score-component">
      <CSS.FlexRow>
        <CSS.FlexColumn>
          <CSS.Title>{`${players.find((player: Player) => player.id === playerId)?.nickName}(${handicap})`}</CSS.Title>
          <CSS.FlexRow>
            <CSS.Asterisk>{strokeIndex <= matchShots ? `*` : ``}</CSS.Asterisk>
            <CSS.CrementButton data-testid={`decrement-button-${playerId}`} onClick={() => decrementScore()}>
              -
            </CSS.CrementButton>
            <CSS.HoleInfo data-testid={`hole-score-${playerId}`}>{playerScore}</CSS.HoleInfo>
            <CSS.CrementButton data-testid={`increment-button-${playerId}`} onClick={() => incrementScore()}>
              +
            </CSS.CrementButton>
          </CSS.FlexRow>
        </CSS.FlexColumn>
        <CSS.FlexColumn>
          <CSS.Title>Points</CSS.Title>
          <CSS.FlexRow>
            <CSS.HoleInfo>{playerPoints}</CSS.HoleInfo>
          </CSS.FlexRow>
        </CSS.FlexColumn>
      </CSS.FlexRow>
    </CSS.ScoreEntryWrapper>
  );
};
